import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import JobCardQuantityDetails from "./JobCardQuantityDetails";
import Button from "react-bootstrap/Button";
import ReportList from "../../../common/ReportList";
import Constants from "../../../../common/Constants";
import moment from "moment/moment";
import { formatDate, formatDateTime } from "../../../../common/Validations";
import ItemService from "../../../../services/commonService";
import { toastFunc } from "../../../../components/common/util";
import AckRecords from "./AckRecords";
import PrintStatusReports from "./PrintStatusReports";

const ProductionStatusReports = () => {
  const { t } = useTranslation();
  const [displayFilter, setDisplayFilter] = useState(false);
  const [openQuantity, setOpenQuantity] = useState(false);
  const [quantityData, setQuantityData] = useState([]);
  const [ackData, setAckData] = useState([]);
  const [ackModel, setAckModal] = useState(false);

  const [jobcard, setJobcard] = useState("");
  const [openViewJobcardCode, setOpenViewJobcardCode] = useState(false);
  const [selectedRows, setSelectedRows] = useState(false);

  const handleViewQuantity = (row) => {
    setOpenQuantity(true);
    let finalRecord = {};
    row?.categories?.forEach((item) => {
      let quantityRecord = {
        ok: [],
        reject: [],
        rework: [],
        consumption: [],
      };

      if (
        Object.keys(finalRecord)?.length !== 0 &&
        finalRecord[item.deptCode]
      ) {
        quantityRecord = finalRecord[item.deptCode];
      }
      if (item.jobstatus === "REJECT") {
        let rejectObj = {};
        rejectObj.rejectCount = item.count;
        rejectObj.rejectReason = item.reasonName;
        rejectObj.date = item.createdDate?.split(" ")[0];
        rejectObj.user = item.createdUserName;
        quantityRecord.reject.push(rejectObj);
      } else if (item.jobstatus === "OK") {
        let okObj = {};
        okObj.okCount = item.count;
        okObj.date = item.createdDate?.split(" ")[0];
        okObj.user = item.createdUserName;
        quantityRecord.ok.push(okObj);
      } else if (item.jobstatus === "CONSUMPTION") {
        let consumptionCount = {};
        consumptionCount.count = item.count;
        consumptionCount.date = item.createdDate;
        consumptionCount.user = item.createdUserName;
        consumptionCount.consumableSize = item.consumableSize;
        consumptionCount.consumptionType = item.consumptionType;
        quantityRecord.consumption.push(consumptionCount);
      } else {
        let reworkObj = {};
        reworkObj.reworkOk = item.reworkOKQuanity;
        reworkObj.reworkReject = item.reworkRejectQuantity;
        reworkObj.reworkDeptCode = item.reworkDeptCode;
        reworkObj.reworkDeptName = item.reworkDeptName;
        reworkObj.date = item.createdDate?.split(" ")[0];
        reworkObj.user = item.createdUserName;
        quantityRecord.rework.push(reworkObj);
      }
      quantityRecord.dept = item.deptName;
      finalRecord[item.deptCode] = quantityRecord;
    });
    setQuantityData(Object.values(finalRecord));
    setJobcard(row.jobcard);
  };

  const handleViewQuantityClose = () => {
    setOpenQuantity(false);
    setQuantityData([]);
    setJobcard("");
  };

  const handleAckModelClose = () => {
    setAckData([]);
    setAckModal(false);
  };
  const handleAckRecords = async (row) => {
    let param = {
      url: "getAckRecordsBasedOnJobcard",
      page: Constants.TRANSACTION.ACKNOLEDGEJOBCARD.name,
      jobcard: row.jobcard,
    };
    try {
      const item = await ItemService.getAckRecordsBasedOnJobcard(param);
      if (item?.status === 200) {
        if (item?.data.length > 0) {
          setAckData(item?.data);
          setAckModal(true);
        }
      } else {
        console.log(">> Error: Loading getApplicationMaster");
      }
    } catch (error) {
      console.error("Error in handleStartStopSuccess:", error);
      toastFunc(
        Constants.MASTER.TOAST.error,
        t("msg_trasaction.msg_teamlead_acknowledge.error_occurred"),
        4000,
      );
    }
  };

  const columnsData = [
    {
      name: t("msg_reports.msg_production_status.job_card"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          <span
            className={`bg-table-status ${row.quantityPerJobCard === 0 ? "bg-table-dark-danger-status" : "bg-table-new-status"}`}
          >
            {row.jobcard}
          </span>
        </>
      ),
      conditionalCellStyles: [
        {
          when: (row) => true, // apply to all rows
          style: {
            position: "sticky",
            left: "0px",
            background: "#fff",
            zIndex: 2,
            boxShadow: "2px 0 5px -2px #ddd",
          },
        },
      ],
    },
    {
      name: t("msg_reports.msg_production_status.customer"),
      selector: (row) => row.customerName,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <span>
          <p className="m-0 p-0 pt-1">{row.customerName} </p>
        </span>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.req_date"),
      selector: (row) => row.requiredDate,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <span>
          <p className="m-0 p-0 pt-1">{formatDate(row.requiredDate)} </p>
        </span>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.sizeCode} </p>
          <p className="m-0 p-0 ">{row.sizeName} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.view_quantity_details"),
      cell: (row) => (
        <button className="btnTable" onClick={() => handleViewQuantity(row)}>
          {row.lastName}
          {"View Quality"}
        </button>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_reports.msg_production_status.order_quantity"),
      selector: (row) => row.batchTotalQuantity,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span
            className={`bg-table-status ${row.quantityPerJobCard === 0 ? "bg-table-dark-danger-status" : "bg-table-text-status"}`}
          >
            {row.originalQuantityPerJobCard} / {row.quantityPerJobCard}
          </span>
        </>
      ),
    },
    {
      name: "Ack Details",
      cell: (row) => (
        <div style={{ width: "100%", textAlign: "center" }}>
          <button className="btnTable" onClick={() => handleAckRecords(row)}>
            Ack Records
          </button>
        </div>
      ),
      width: "150px",
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard_status"),
      selector: (row) => row.jobcardStatus,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <>
          {row.jobcardStatus === "Inprogress" ? (
            <span className="bg-table-status bg-table-progress-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Open" ? (
            <span className="bg-table-status bg-table-new-status">
              {/* {row.jobcardStatus} */}
              NOT Acknowledged
            </span>
          ) : row.jobcardStatus === "Stopped" ? (
            <span className="bg-table-status bg-table-danger-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Acknowledged" ? (
            <span className="bg-table-status bg-table-success-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Closed" ? (
            <span className="bg-table-status bg-table-info-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Complete" ? (
            <span
              className={`bg-table-status ${row.quantityPerJobCard === 0 ? "bg-table-dark-danger-status" : "bg-table-documentNumber-status"}`}
            >
              {row.jobcardStatus}
            </span>
          ) : (
            <>{row.jobcardStatus}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.completedDate"),
      selector: (row) => row.completedDate,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <span>
          <p className="m-0 p-0 pt-1">{formatDateTime(row.completedDate)} </p>
        </span>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_fromDepartment"),
      selector: (row) => row.fromDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          {row.fromDeptCode ? (
            <span className="bg-table-status bg-table-first-status">
              {row.fromDeptCode} - {row.fromDeptName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_toDepartment"),
      selector: (row) => row.toDeptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-second-status">
            {row.toDeptCode} - {row.toDeptName}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_priority"),
      selector: (row) => row.priority,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          {row.priority === "urgent" ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_overview.urgent")}
            </span>
          ) : row.priority === "regular" ? (
            <span className="bg-table-status bg-table-info-status">
              <strong>{t("msg_overview.regular")}</strong>
            </span>
          ) : (
            <>{row.priority}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.plan"),
      selector: (row) => row.plan,
      sortable: true,
      width: "100px",
      cell: (row) => (
        <span>
          <p className="m-0 p-0 pt-1">{moment(row.plan).format("MMM-YYYY")}</p>
        </span>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.plan"),
      selector: (row) => row.planType,
      sortable: true,
      width: "100px",
      cell: (row) => (
        <span>
          <p className="m-0 p-0 pt-1">{row.planType}</p>
        </span>
      ),
    },
  ];
  const handlePrintClick = () => {
    if (selectedRows) {
      setOpenViewJobcardCode(true);
    }
  };
  const resetJobcardModal = () => {
    setOpenViewJobcardCode(false);
  };
  const handleSelectedRowsChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };

  return (
    <main className="generatejobcard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t("msg_reports.msg_production_status.production_status_reports")}
            </h2>
            <p className="subText">
              {t("msg_reports.msg_production_status.details_page")}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="leftSide">
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <i class="bi bi-filter"> </i>
          </Button>
          <Button
            variant="primary"
            className="float-right mr-8"
            onClick={handlePrintClick}
          >
            {"PRINT"}
          </Button>{" "}
        </Col>
        <hr />
      </Row>
      <div>
        <ReportList
          columnsData={columnsData}
          displayProdStatusFilter={displayFilter}
          resetFilerBox={setDisplayFilter}
          handleSelections={handleSelectedRowsChange}
          pageName={Constants.REPORTS.PRODUCTIONSTATUS.pageName}
          pageURL={Constants.REPORTS.PRODUCTIONSTATUS.list}
          name={Constants.REPORTS.PRODUCTIONSTATUS.name}
          selectableRows
        />
        {openQuantity && (
          <JobCardQuantityDetails
            rowsData={quantityData}
            show={openQuantity}
            onHide={handleViewQuantityClose}
            jobcard={jobcard}
          ></JobCardQuantityDetails>
        )}

        {ackModel && (
          <AckRecords
            rowsData={ackData}
            show={ackModel}
            onHide={handleAckModelClose}
            jobcard={jobcard}
          ></AckRecords>
        )}

        {openViewJobcardCode && (
          <PrintStatusReports
            selectedItems={selectedRows}
            show={openViewJobcardCode}
            onHide={() => {
              resetJobcardModal();
            }}
          ></PrintStatusReports>
        )}
      </div>
    </main>
  );
};

export default ProductionStatusReports;
